<template>
  <div class="container-fluid">
    <ModalGestionBarquettes ref="gestionBarquette" @refreshBarquette="chargerBarquettes()" />

    <BarreActions :actions="actions" @appliquer-action="executerAction($event)" />

    <div class="card table-scroll height-responsive-100">
      <table class="table table-bordered table-sm text-center table-header">
        <colgroup>
          <col>
          <col width="200">
          <col width="80">
        </colgroup>
        <thead>
          <th class="aligner-gauche">Designation</th>
          <th>Taille (Nombre de portions)</th>
          <th>Active</th>
        </thead>
      </table>
      <div class="table-body">
        <table class="table table-bordered table-sm text-center">
          <colgroup>
            <col>
            <col width="200">
            <col width="75">
          </colgroup>
          <tbody>
            <template v-for="(barquette, iBarquette) in listeBarquettes">
              <tr :class="[{'ligne-selectionnee':barquette.id === idBarquetteSelectionnee}, {'ligne-desactivee':!barquette.active}]" :key="iBarquette" @click="selectionnerBarquette(barquette)">
                <td class="aligner-gauche">{{ barquette.designation }}</td>
                <td class="aligner-gauche">{{ barquette.taille }}</td>
                <td>
                  <i v-if="barquette.active" title="Barquette active" class="fas fa-check" style="margin-right:2px;vertical-align:middle;"></i>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  
</template>

<script>
import BarreActions from '@/components/Divers/BarreActions'
import { obtenirBarquettes, supprimerBarquette } from '@/api/gpao/production'
import { connecteData } from "@/mixins/connecteData"
import { showAlerts } from "@/mixins/alerts"
import ModalGestionBarquettes from '@/components/Divers/ModalGestionBarquettes.vue'

export default {
  components: { BarreActions, ModalGestionBarquettes },
  mixins: [ connecteData, showAlerts ],
  name: "PageBarquettage",
  data() {
    return {
      barquetteSelectionee: {},
      idBarquetteSelectionnee: null,
      listeBarquettes: [],
      actions: {
        // Boutons à afficher dans la barre d'action
        // Exemple :
        /*
        nomAction: {
          label: Label affiché sur le bouton (string),
          disabled: Etat actif/inactif par défaut du bouton (bool),
          class: Classe CSS (btn-primary, btn-success, btn-warning ou btn-danger) à appliquer sur le bouton (par défaut : "btn-primary" est appliqué => il s'agit du bouton bleu Agap'pro) (string)
          methode(contexte) {
            // => contexte équivaut à this (mais this ne fonctionne pas car l'initialisation de data n'est pas encore terminée, donc data n'est pas encore rattaché à this)
            traitements à exécuter lors du clic sur le bouton
            les traitements définis dans cette page doivent être appelés sous la forme : contexte.traitement()

            Remarque : pour que le système fonctionne, il faut déclarer la méthode ci-dessous dans la section "methods" de cette page
            executerAction(methode) {
              methode(this)
            }

          }
        }
        */
        ajouter: {
          label: "Ajouter une barquette",
          async methode(contexte) {
            contexte.ajouterBarquette()
          }
        },
        ouvrir: {
          label: "Ouvrir",
          disabled: true,
          methode(contexte) {
            let l = contexte.barquetteSelectionnee
            if (l) {
              contexte.modifierBarquette(l.id)
            }
          }
        },
        supprimer: {
          label: "Supprimer",
          disabled: true,
          class: "btn-danger",
          methode(contexte) {
            let cmd = contexte.barquetteSelectionnee
            if (cmd) {
              contexte.supprimerBarquette(cmd.id)
            }
          }
        },
        // Appeler "this.actions.initialiser(this)"" dans mounted() => génère les tableaux d'actions utilisés pour afficher les boutons à gauche et à droite de la barre d'actions
        barreGauche: [],
        barreDroite: [],
        initialiser(contexte) {
          contexte.actions.barreGauche = [ contexte.actions.ajouter ]
          contexte.actions.barreDroite = [ contexte.actions.ouvrir, contexte.actions.supprimer ]
        },
        // A gérer en cas de boutons à activer/désactiver (créer une méthode par groupe de boutons à activer/désactiver)
        disable(actions, disabled) {
          let actionsATraiter = [ actions.ouvrir, actions.supprimer ]
          actionsATraiter.forEach(a => a.disabled = disabled)
        }
      }
    }
  },
  mounted() {
    this.chargerBarquettes()
    this.actions.initialiser(this)  
  },
  computed: {
    barquetteSelectionnee() {
      return this.listeBarquettes?.find(c => c.id === this.idBarquetteSelectionnee)
    }  
  },
  watch: {
    
  },
  methods: {
    executerAction(methode) {
      // Nécessaire pour faire fonctionner les actions de la barre d'actions'
      methode(this)
    },
    async chargerBarquettes() {
      var response = await obtenirBarquettes(this.etabCourant.eId)
      this.listeBarquettes = response.data
    },  
    ajouterBarquette() {
      let vueBarquette = {
        taille: 0,
        designation: "",
        id: 0,
        active: true,
        etablissementId: this.etabCourant.eId
      }

      this.$refs.gestionBarquette.show(vueBarquette, this.listeBarquettes)
    },
    async supprimerBarquette(barqId) {
      let result = await this.alerteConfirmation("Supprimer une barquette", "Souhaitez-vous supprimer la barquette \"" + this.barquetteSelectionnee.designation + "\" ?")
      if (result) {
        await supprimerBarquette(barqId)
        await this.chargerBarquettes()
      }
    },
    modifierBarquette(barqId) {
      let vueBarquette = this.listeBarquettes.filter(x => x.id == barqId).first()
      let autres = this.listeBarquettes.filter(x => x.id != barqId)
      this.$refs.gestionBarquette.show(vueBarquette, autres)
    },
    selectionnerBarquette(barq) {
      if (barq.id === this.idBarquetteSelectionnee) {
        this.modifierBarquette(barq.id)
        return
      }
      this.idBarquetteSelectionnee = barq.id
      this.actions.disable(this.actions, !this.barquetteSelectionnee)
    }
  }
}
</script>
